import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, Typography } from "@mui/material";
import InputWithLabel from "../../shared/components/InputWithLabel";
import CustomPrimaryButton from "../../shared/components/CustomPrimaryButton";
import { fileToDataUrl } from "../../shared/utils/files";
import * as api from "../../api";
import { connect } from "react-redux";
import { updateServer } from "../../store/actions/roomActions";

const ServerSettingsDialog = ({ open, onClose, server, updateServer }) => {
  const [name, setName] = useState("");
  const [iconUrl, setIconUrl] = useState("");

  useEffect(() => {
    if (open) {
      setName(server?.name || "");
      setIconUrl(server?.iconUrl || "");
    }
  }, [open, server]);

  const handleIconChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setIconUrl(await fileToDataUrl(file));
  };

  const handleSave = async () => {
    const response = await api.updateServerSettings({ serverId: server.id, name, iconUrl });
    if (!response.error) {
      updateServer(response.data.server);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx:{ bgcolor:"#282a30", color:"#f2f3f5", borderRadius:"8px", width:"440px", p:"24px" } }}>
      <Typography sx={{ fontSize:"20px", fontWeight:800 }}>Настройки сервера</Typography>
      <Box sx={{ display:"flex", alignItems:"center", gap:"14px", mt:"18px" }}>
        <Box sx={{ width:54, height:54, borderRadius:"16px", bgcolor:"#f97316", backgroundImage: iconUrl ? `url(${iconUrl})` : "none", backgroundSize:"cover", backgroundPosition:"center", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:800 }}>
          {!iconUrl && name.substring(0,2).toUpperCase()}
        </Box>
        <Button component="label" sx={{ color:"#fff", bgcolor:"#3a3c43", textTransform:"none", "&:hover":{bgcolor:"#4e5058"} }}>
          Иконка
          <input hidden type="file" accept="image/*" onChange={handleIconChange} />
        </Button>
      </Box>
      <InputWithLabel label="Название" value={name} setValue={setName} type="text" placeholder="" />
      <Box sx={{ display:"flex", gap:"12px", mt:"22px" }}>
        <CustomPrimaryButton label="Отмена" onClick={onClose} additionalStyles={{ background:"#4e5058" }} />
        <CustomPrimaryButton label="Сохранить" onClick={handleSave} disabled={name.trim().length < 2} />
      </Box>
    </Dialog>
  );
};

export default connect(null, { updateServer })(ServerSettingsDialog);
